var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-title ellipsis",class:_vm.titleClassName},[_vm._v(_vm._s(_vm.benefitName))]),_c('div',{staticClass:"banner-image",style:({ backgroundImage: 'url(' + _vm.getImage + ')' })})])}
var staticRenderFns = []

export { render, staticRenderFns }